/* eslint-disable */
// @ts-nocheck
import { copy, cut, isSupported } from "clipboard";

const small_s = 1000;
const small_e = 1250;

/**
 * 数组分组
 * @param array
 * @param subGroupLength
 * @param index
 * @param newArray
 * @returns
 */
export const group = (
  array: any,
  subGroupLength: number,
  index = 0,
  newArray = []
) => {
  while (index < array.length) {
    newArray.push(array.slice(index, (index += subGroupLength)));
  }
  return newArray;
};

export const maxMetric = (metrics: any = []) =>
  Math.max(...metrics.map((item) => Object.values(item)[0]));

export const markEvaluation = (evaluations: any = []) => {
  const _evaluations = [];
  evaluations.forEach((item = {}) => {
    const name = item.techTask ? item.techTask.commonName : "";
    const metrics = item.metrics || [];
    _evaluations.push({
      ...item,
      name,
      max: maxMetric(metrics),
    });
  });
  return _evaluations;
};

export const removeMinEvaluation = (evaluations: any = []) => {
  const markList = markEvaluation(evaluations);
  const _evaluations = [];
  markList.forEach((item = {}) => {
    const index = _evaluations.findIndex((_item) => _item.name === item.name);
    if (index !== -1 && item.max > _evaluations[index].max) {
      _evaluations.splice(index, 1, item);
    } else if (index === -1) {
      _evaluations.push(item);
    }
  });
  return _evaluations;
};

export const expandTableData = (data, key = "metrics") =>
  data.reduce((result, item) => {
    item[key].forEach((newItem) => {
      result.push({
        ...item,
        key: Object.keys(newItem)[0],
        value: Object.values(newItem)[0],
      });
    });
    return result;
  }, []);

export const formatTableData = (data) =>
  data
    .reduce((result, item) => {
      if (result.indexOf(item.id) < 0) {
        result.push(item.id);
      }
      return result;
    }, [])
    .reduce((result, id) => {
      const children = data.filter((item) => item.id === id);
      result = result.concat(
        children.map((item, index) => ({
          ...item,
          rowSpan: index === 0 ? children.length : 0, //将第一行数据添加rowSpan字段
        }))
      );
      return result;
    }, []);

/**
 * ios版本
 * @param ua
 * @returns
 */
export const iosVer = (ua) =>
  Number(ua.match(/cpu iphone os (.*?) like mac os/)?.[1].split("_")[0]);

/**
 * 手机safari判定
 * @returns
 */
export const isPhoneSafari = () => {
  const ua = navigator.userAgent.toLowerCase();
  return (
    ua.indexOf("applewebkit") > -1 &&
    ua.indexOf("mobile") > -1 &&
    ua.indexOf("safari") > -1 &&
    ua.indexOf("linux") == -1 &&
    ua.indexOf("android") == -1 &&
    /Safari/.test(navigator.userAgent) &&
    !/Chrome/.test(navigator.userAgent) &&
    iosVer(ua) < 15
  );
};

/**
 * 自制latex规则化
 * @param str
 * @returns
 */
export const formatLateX = (str) =>
  str
    ? str.replace(
        /(\$\$[^\$\$]*\$\$|\$[^\$]*\$)/g,
        (match) => {
          return match.replace(/\s*/g, "");
        },
        ""
      )
    : "";

/**
 * 设置css变量
 * @param cssVar
 * @param ele
 */
export const calcLayout = (cssVar: string, ele: any) => {
  //@ts-ignore
  if (typeof ele === "number") {
    //@ts-ignore
    document.body.style.setProperty(cssVar, `${ele}px`);
  } else {
    if (ele && ele.current) {
      //@ts-ignore
      document.body.style.setProperty(cssVar, `${ele.current.offsetHeight}px`);
    } else {
      //@ts-ignore
      document.body.style.setProperty(cssVar, "0px");
    }
  }
};

/**
 * 引导条js注入
 * @param hooks
 * @returns
 */
export const guideJs = (hooks) => {
  const { useState, useRef, useEffect } = hooks;
  const [guideShow, setGuideShow] = useState(
    document.body.clientWidth < 768 && true
  );
  const guideEle = useRef(null);

  useEffect(() => {
    calcLayout("--guide-height", guideEle);
  }, [guideShow]);

  return {
    guideEle,
    guideShow,
    setGuideShow,
  };
};

/**
 * 广告条js注入
 * @param hooks
 * @returns
 */
export const adJs = (hooks) => {
  const { useState, useRef, useEffect } = hooks;
  const [adShow, setAdShow] = useState(false);
  const adEle = useRef(null);

  useEffect(() => {
    calcLayout(
      "--ad-height",
      isMobile() ? (adEle && adEle.current ? 68 : 0) : adEle
    );
  }, [adShow]);

  return {
    adEle,
    adShow,
    setAdShow,
  };
};

/**
 * 底部js注入
 * @param hooks
 * @returns
 */
export const bottomJs = (hooks) => {
  const { useState, useRef, useEffect } = hooks;
  const [bottomShow, setBottomShow] = useState(false);
  const bottomEle = useRef(null);

  useEffect(() => {
    calcLayout("--bottom-height", bottomEle);
  }, [bottomShow]);

  return {
    bottomEle,
    bottomShow,
    setBottomShow,
  };
};

/**
 * 手机端判定
 * @returns
 */
export const isMobile = () => {
  return /Mobi|Android|iPhone/i.test(navigator.userAgent) || isPad();
};

export const addWindowQueue = (name) => {
  window[`${name}Queue`] = [];
};

export const addResizeListener = (callback, immediate = true) => {
  const handleResize = (isFirst) => {
    // 调用回调函数，并传入当前是否是移动端的布尔值 (不清楚为什么第一时间拿不到，需要等一下re-render)
    if (isFirst) {
      window.resizeEventQueue.forEach((fn) => fn(isMobile()));
    } else {
      setTimeout(() => {
        window.resizeEventQueue.forEach((fn) => fn(isMobile()));
      });
    }
  };

  // 监听窗口的 resize 事件
  if (window.resizeEventQueue.length === 0) {
    window.addEventListener("resize", handleResize, false);
  }
  window.resizeEventQueue.push(callback);

  // 立即执行一次，以确保在屏幕尺寸变化前也能获取到当前状态
  immediate && handleResize(true);

  // 返回一个函数，用于取消监听
  return () => {
    window.removeEventListener("resize", handleResize, false);
  };
};

/**
 * 响应式手机端判定
 * @returns
 */
export const reactiveIsMobile = (callback: (res: boolean) => void) => {
  addResizeListener(callback);
};

/**
 * 新页面打开
 * @param url
 * @param target
 * @param history
 * @returns
 */
export const openNew = (
  url: string,
  target?: "_blank" | "_self",
  history?: any
) => {
  if (!url) {
    return false;
  }
  const _url = autoFixPath(url);
  const _target = target || "_blank";
  if (isMobile()) {
    if (history) {
      history.push(_url);
    } else {
      window.open(_url, _target);
    }
  } else {
    window.open(_url, _target);
  }
};

/**
 * 封装immer
 * @param data
 * @returns
 */
export const produceSync = (data: any): any => produce(data, (draft) => draft);

export const getQuery = (variable: string): string => {
  const query = window.location.search.substring(1);
  const vars = query.split("&");
  for (let i = 0; i < vars.length; i++) {
    const pair = vars[i].split("=");
    if (pair[0] == variable) {
      return pair[1];
    }
  }
  return "";
};

/**
 * 获取查询参数
 * @param path
 * @returns
 */
export const getParams = (path: string): string => {
  const index = path.split("").filter((it: string) => it === "/").length + 1;
  return (location as any).href
    .match(new RegExp(`${path}/.*`))[0]
    .split("/")
    [index].replace(/\?.*/, "");
};

/**
 * 自定义重复点击事件
 * @param data
 */
export const onRepeatedlyClick = (data: any) => {
  const {
    element = document.body,
    clickCount = 10,
    callBack = () => {},
  } = data;
  const waitTime = 200;
  let lastTime = new Date().getTime();
  let count = 0;

  element.addEventListener(
    "click",
    () => {
      const currentTime = new Date().getTime();
      count = currentTime - lastTime < waitTime ? count + 1 : 0;

      if (count > clickCount - 1) {
        callBack();
        count = 0;
      }

      lastTime = new Date().getTime();
    },
    false
  );
};

/**
 * 图片区域截图
 * @param opts
 * @returns
 */
export const imgShot = (opts) => {
  const { img, rect } = opts;
  if (!img || !rect) {
    throw new Error("opts params Error!");
  }
  img.crossOrigin = "anonymous";
  const canvas = document.createElement("canvas");
  const ctx = canvas.getContext("2d");
  const { x, y, width, height } = rect;
  canvas.width = width;
  canvas.height = height;
  ctx.drawImage(img, x, y, width, height, 0, 0, width, height);
  const url = canvas.toDataURL("image/png");
  return url;
};

/**
 * 是否微信
 * @returns
 */
export const isWx = () => /MicroMessenger/i.test(window.navigator.userAgent);

/**
 * url替换
 */
export const replace = () => {
  setTimeout(() => {
    const url = (window as any).location.href.replace(
      (window as any).location.origin,
      ""
    );
    history.replace(url);
  }, 300);
};

/**
 * win判定
 * @returns
 */
export const isWin = () => /windows|win32/i.test(navigator.userAgent);

/**
 * edge判断
 * @returns
 */
export const isEdge = () => navigator.userAgent.indexOf("Edg") > -1;

/**
 * 获取wiki
 * @param id
 * @returns
 */
export const getWikiUrl = (id) =>
  `https://www.jiqizhixin.com/graph/technologies/${id}?unveil=base`;

/**
 * 中文判定
 * @param str
 * @returns
 */
export const isChinese = (str: string) =>
  /[\u4E00-\u9FCC\u3400-\u4DB5\uFA0E\uFA0F\uFA11\uFA13\uFA14\uFA1F\uFA21\uFA23\uFA24\uFA27-\uFA29]|[\ud840-\ud868][\udc00-\udfff]|\ud869[\udc00-\uded6\udf00-\udfff]|[\ud86a-\ud86c][\udc00-\udfff]|\ud86d[\udc00-\udf34\udf40-\udfff]|\ud86e[\udc00-\udc1d]/.test(
    str
  );

/**
 * 通讯录按字母排序
 * @param data
 * @param field
 * @returns
 */
export const sortAndGroup = (data: any, field: string) => {
  if (!data.length) {
    return [];
  }
  const indexList = [
    "A",
    "B",
    "C",
    "D",
    "E",
    "F",
    "G",
    "H",
    "I",
    "J",
    "K",
    "L",
    "M",
    "N",
    "O",
    "P",
    "Q",
    "R",
    "S",
    "T",
    "U",
    "V",
    "W",
    "X",
    "Y",
    "Z",
    "#",
  ];
  const res = [];
  indexList.forEach((key: string) => {
    const keyed = data.filter((item: any) => item[field] === key);
    if (keyed.length > 0) {
      res.push({
        title: key,
        items: keyed,
      });
    }
  });
  return res;
};

/**
 * 跟踪空降
 */
export const track = () => {
  const airborne = sessionStorage.getItem("airborne");
  if (!airborne) {
    sessionStorage.setItem("airborne", "ok");
    window.airborne = true;
  } else {
    window.airborne = false;
  }
};

/**
 * 取消跟踪空降
 */
export const untrack = () => {
  sessionStorage.removeItem("airborne");
};

/**
 * 模拟手机端表现
 */
export const simulateMobile = () => {
  const set = () => {
    const t = document.getElementsByTagName("html")[0];
    t.classList.remove("s-mobile");
    if (!isMobile()) {
      t.classList.add("s-mobile");
    }
  };
  set();
  addResizeListener(set);
};

/**
 * 停止模拟手机端表现
 */
export const stopSimulateMobile = () => {
  const t = document.getElementsByTagName("html")[0];
  t.classList.remove("s-mobile");
};

/**
 * 判定是否模拟手机端表现
 */
export const isSimulateMobile = () =>
  document.getElementsByClassName("s-mobile").length > 0;

/**
 * 业务路径自动兼容
 * @param path
 * @param check
 * @returns
 */
export const autoFixPath = (path: any, check = true) => {
  let _path = path;
  if (check) {
    if (isMobile() && _path.includes("/implements")) {
      _path = _path.replace("/implements", "/resources");
    }
    if (!isMobile() && _path.includes("/resources")) {
      _path = _path.replace("/resources", "/implements");
    }
  }
  return _path;
};

/**
 * 获取宽高
 * @returns
 */
export const getWh = () => {
  return {
    width: document.body.clientWidth,
    height: document.body.clientHeight,
  };
};

/**
 * 设置设备尺寸到css变量
 */
export const setScreen = () => {
  const setVw = (width, height) =>
    document.body.style.setProperty("--my-vw", `${width}px`);
  const setVh = (width, height) =>
    document.body.style.setProperty("--my-vh", `${height}px`);
  const setVwNumber = (width, height) =>
    document.body.style.setProperty("--my-vw-number", width);
  const setRootSize = (width, height) => {
    const base = width < height ? width : height;
    document.querySelector("html").style.fontSize =
      `${(base / 10).toFixed(1)}px`;
  };
  // 持续回调
  const cb = () => {
    const { width, height } = getWh();
    setVw(width, height);
    setVh(width, height);
    setVwNumber(width, height);
    setRootSize(width, height);
  };
  addResizeListener(cb);
};

/**
 * 判定ipad
 * @returns
 */
export const isPad = () => {
  const ua = navigator.userAgent;
  const isAndroid = /(?:Android)/.test(ua);
  const isFireFox = /(?:Firefox)/.test(ua);
  return (
    /(?:iPad|PlayBook)/.test(ua) ||
    (isAndroid && !/(?:Mobile)/.test(ua)) ||
    (isFireFox && /(?:Tablet)/.test(ua))
  );
};

/**
 * 判定横屏
 * @returns
 */
export const mobileRow = () => {
  return (
    isMobile() &&
    screen.width <= small_e &&
    (window.orientation === 90 || window.orientation === -90)
  );
};

/**
 * 是否小屏
 * @returns
 */
export const isSmall = () => {
  return (
    !isMobile() &&
    document.body.clientWidth >= small_s &&
    document.body.clientWidth <= small_e
  );
};

/**
 * rem js 换算函数
 * @param pixels
 * @returns
 */
export const rem = (pixels) => {
  const vw_design = 375;
  return isMobile() ? `${(pixels / vw_design) * 10}rem` : `${pixels}px`;
};

/**
 * 返回上级路由
 * @param history
 * @param path
 */
export const goBack = (history: any, path?: string) => {
  if (window.airborne) {
    history.replace(path || "/");
  } else {
    history.goBack();
  }
};

/**
 * 缩放屏幕
 */
export const scaleScreen = () => {
  const base = small_e;
  const root = document.getElementsByTagName("html")[0];

  const scale = () => {
    if (screen.width >= small_s && screen.width <= base) {
      if (isPad()) {
        root.style.zoom = 1;
      } else {
        root.style.zoom = (screen.width / base).toFixed(2);
      }
    } else {
      root.style.zoom = 1;
    }
  };

  addResizeListener(scale);
};

// 得到最终选择的DOM或要复制的文本
const getSelected = (
  init: string | Element,
  isDomSelector = false
): string | Element => {
  if (!init) throw new Error("Do not pass an empty value!");

  let selected: string | Element;

  /*
   * 只有在init类型为string且是个DOM选择器时执行选择DOM操作
   * 否则直接将init值赋给selected
   */
  if (typeof init === "string" && isDomSelector) {
    const selectedDom = document.querySelector(init);
    if (selectedDom) selected = selectedDom;
    else throw new Error("Expected be an existed DOM");
  } else selected = init;

  return selected;
};

/**
 * 复制动作
 * @param init {string | Element} 可以是字符串或DOM选择器，也可以是DOM元素
 * @param isDomSelector {boolean} 是否为DOM选择器字符串。
 * @returns 复制后的内容
 */
export function useCopy(
  init: string | Element,
  isDomSelector = false
): Promise<string> {
  // 支持检查
  if (!isSupported())
    throw new Error("Sorry, your browser does not support Clipboard.js!");

  // 调用上面的函数
  const selected = getSelected(init, isDomSelector);

  // Promise封装异步操作
  return new Promise<string>((resolve, reject) => {
    const copied = copy(selected);
    copied
      ? resolve(copied)
      : reject("You just have copied something empty! Try once again!");
  });
}

/**
 * 剪切动作
 * @param init {string | Element} 可以是字符串或DOM选择器，也可以是DOM元素
 * @param isDomSelector {boolean} 是否为DOM选择器字符串。
 * @returns 复制后的内容
 */
export function useCut(
  init: string | Element,
  isDomSelector = false
): Promise<string> {
  // 支持检查
  if (!isSupported())
    throw new Error("Sorry, your browser does not support Clipboard.js!");

  // 调用上面的函数
  const selected = getSelected(init, isDomSelector);

  // Promise封装异步操作
  return new Promise<string>((resolve, reject) => {
    const cutContent = cut(selected);
    cutContent
      ? resolve(cutContent)
      : reject("You just have cut something empty! Try once again!");
  });
}

/**
 * 节点文本是否溢出
 * @param node 文本的节点
 * @returns
 */
export const isTextOver = (node: any, style?: any) => {
  const _style = style || {};
  const fb: any = document.querySelector(".is-text-over");
  fb.innerText = node.innerText;
  for (const prop in _style) {
    fb.style[prop] = _style[prop];
  }
  return fb.clientWidth > node.clientWidth;
};

/**
 * 特殊格式文本生成
 * @param arr 文本的集合
 * @param symbol 符号
 * @returns
 */
export const bioGenerator = (arr: any, symbol?: string = " · ") => {
  return {
    isEmpty: arr.every((item: string) => !item),
    res: arr.filter((item: string) => item).join(symbol),
  };
};

/**
 * 生成全自然年
 * @param minYear 最小年限
 * @param format 转换器函数
 * @returns
 */
export const generatorYears = (
  format?: any = (year: number) => year,
  minYear?: number = 1900
) => {
  const nowYear = new Date().getFullYear();
  const allYears = [];

  let lastYear = nowYear;
  while (lastYear >= minYear) {
    allYears.push(lastYear);
    lastYear--;
  }

  const res = allYears.map((year: number) => format(year));
  return res;
};

/**
 * 计算经验年限
 * @param 入行年
 * @returns
 */
export const calcYear = (beginAi: string | number) => {
  // const setYear = () => {
  //   const year = new Date().getFullYear() - Number(beginAi);
  //   return year > 0 ? year + "年经验" : "1年经验";
  // };
  // return beginAi ? setYear() : "";
  return beginAi ? beginAi + "年开始搞AI" : "";
};

/**
 * 设置 ant uploadProps 支持单文件本地暂存
 * @param file ant 抛出的file
 * @param setFileList 上传文件列表
 * @param setFileUrl 预览链接设置
 * @param callback 自定义回调
 */
export const setOneFile = (
  file: any,
  setFileList?: any,
  setFileUrl?: any,
  callback?: any
) => {
  const reader = new FileReader();
  reader.readAsDataURL(file);
  reader.onload = function () {
    setFileList && setFileList([file]);
    setFileUrl && setFileUrl(this.result);
    callback && callback(file);
  };
};

/**
 * 解决js精度问题
 * @param a
 * @param b
 * @param operation
 * @returns
 */
export const preciseCalculation = (
  a: number,
  b: number,
  operation: "add" | "subtract" | "multiply" | "divide"
) => {
  const countDecimals = (num: number) => {
    if (typeof num !== "number") return 0;
    let match = `${num}`.match(/(?:\.(\d+))?(?:[eE]([+-]?\d+))?$/);
    if (!match) {
      return 0;
    }
    return Math.max(
      0,
      (match[1] ? match[1].length : 0) - (match[2] ? +match[2] : 0)
    );
  };

  const maxDecimals = Math.max(countDecimals(a), countDecimals(b));
  const multiplier = Math.pow(10, maxDecimals);

  switch (operation) {
    case "add":
    case "subtract":
      // 对于加减法，直接计算后调整精度，避免四舍五入可能带来的误差
      const result = operation === "add" ? a + b : a - b;
      return parseFloat(result.toFixed(maxDecimals));

    case "multiply":
      // 直接计算乘积，然后根据结果的小数位数和期望精度调整
      const product = a * b;
      return parseFloat(product.toFixed(maxDecimals));

    case "divide":
      if (b === 0) throw new Error("Divide by zero error.");
      // 计算商，然后根据a和b的小数位数差异调整结果精度
      const quotient = a / b;
      return parseFloat(quotient.toFixed(maxDecimals - countDecimals(b)));

    default:
      throw new Error(
        'Invalid operation type. Use "add", "subtract", "multiply", or "divide".'
      );
  }
};

/**
 * 模拟用户权限
 */
export const mockAuth = (value: string, fn?: any) => {
  localStorage.setItem("good-auth", value);
  fn ? fn() : location.reload();
};

/**
 * 删除url指定的查询参数
 * @param url  string
 * @param paramsToRemove array
 * @returns
 */
export const removeQueryParams = (url: string, paramsToRemove: any) => {
  // 解析URL
  const urlObj = new URL(url);

  // 遍历要删除的参数
  paramsToRemove.forEach((param) => {
    // 检查URL的searchParams中是否有该参数
    if (urlObj.searchParams.has(param)) {
      // 删除参数
      urlObj.searchParams.delete(param);
    }
  });

  // 构建没有指定参数的URL
  const newUrl = urlObj.href.split("?")[0]; // 获取没有查询参数的基础URL
  const params = urlObj.searchParams.toString(); // 获取剩余的查询参数字符串
  if (params) {
    return `${newUrl}?${params}`; // 如果还有剩余参数，拼接它们
  }
  return newUrl; // 如果没有剩余参数，返回基础URL
};

export const replaceAll = (
  str: string,
  o: string,
  n: string,
  model?: string
) => {
  const reg = new RegExp(`${o}`, model || "g");
  return str.replace(reg, n);
};

export type ENVS = "local" | "test" | "prod";
export const getEnv = (): ENVS => {
  const envs = {
    localhost: "local",
    "sota.almosthuman.cn": "test",
    "sota.jiqizhixin.com": "prod",
  };
  return window.env ? window.env : (window.env = envs[location.hostname]);
};

export const RandomGenerator = {
  // 均匀分布随机数
  uniform(min: number, max: number) {
    return Math.floor(Math.random() * (max - min + 1) + min);
  },

  // 正态分布随机数（使用Box-Muller变换）
  normal(mean: number, stdDeviation: number) {
    let u = 0;
    let v = 0;
    let s = 0;
    let z0 = 0;
    let z1 = 0;

    do {
      u = Math.random();
      v = 1.2 * (Math.random() - 0.5);
      s = u * u + v * v;
    } while (s >= 1 || s == 0);

    const factor = Math.sqrt((-2 * Math.log(s)) / s);
    z0 = u * factor;
    z1 = v * factor;

    return mean + z1 * stdDeviation;
  },

  // 泊松分布随机数
  poisson(lambda: number) {
    const L = Math.exp(-lambda);
    let k = 0;
    let p = 1;

    do {
      k++;
      p *= Math.random();
    } while (p > L);

    return k - 1;
  },

  // 指数分布随机数
  exponential(lambda: number) {
    return -Math.log(1 - Math.random()) / lambda;
  },
};

export const setVars = (obj?: any) => {
  window.vars = {
    $primary: "#ed701b",
    "$primary--hover": "#e06a19",
    "$primary--active": "#e06a19",
    "$primary--1": "rgba(237, 112, 27, 0.1)",
    "$primary--5": "rgba(237, 112, 27, 0.5)",
    "$header-height--mobile": rem(50),
    ...obj,
  };
};

// 深拷贝
export const deepClone = (obj, hash = new WeakMap()) => {
  // 检查传入的是否为null或undefined，直接返回
  if (obj == null) return obj;

  // 检查传入的是否为日期对象，直接返回一个新的日期对象
  if (obj instanceof Date) return new Date(obj);

  // 检查传入的是否为RegExp对象，直接返回一个新的RegExp对象
  if (obj instanceof RegExp) return new RegExp(obj);

  // 如果循环引用了就用weakMap来解决
  if (hash.has(obj)) return hash.get(obj);

  // 处理数组
  let allDesc = Object.getOwnPropertyDescriptors(obj);
  let cloneObj = Array.isArray(obj) ? [] : {};
  hash.set(obj, cloneObj);

  for (let key of Reflect.ownKeys(obj)) {
    if (typeof obj[key] === "object" && obj[key] !== null) {
      cloneObj[key] = deepClone(obj[key], hash); // 递归复制
    } else {
      // 复制原始值
      Object.defineProperty(cloneObj, key, allDesc[key]);
    }
  }

  return cloneObj;
};

// 深拷贝文件
export const deepCloneFile = (
  file,
  newFileName = file.name,
  newFileType = file.type
) => {
  // 创建一个新的Blob对象，它引用与原始File对象相同的文件内容
  const blob = new Blob([file], { type: file.type });

  // 使用File构造函数创建一个新的File对象
  // 注意：这里的第二个参数是一个数组，包含文件名，但在这个场景下我们只需要一个文件名
  // 第三个参数是文件的选项对象，可以指定文件的类型等，但在这里我们主要关注文件名和类型
  const clonedFile = new File([blob], newFileName, {
    type: newFileType,
    lastModified: file.lastModified,
  });

  return clonedFile;
};

export async function copyToClipboard(text: string) {
  try {
    await navigator.clipboard.writeText(text);
    console.log("复制成功!");
  } catch (error) {
    const textArea = document.createElement("textarea");
    textArea.value = text;
    document.body.appendChild(textArea);
    textArea.focus();
    textArea.select();
    try {
      document.execCommand("copy");
      console.log("复制成功!");
    } catch (error) {
      console.log("复制失败!");
    }
    document.body.removeChild(textArea);
  }
}

export function getDeviceInfoFromUserAgent() {
  var userAgent = navigator.userAgent;
  var deviceInfo: any = {};

  // 检测是否为移动设备
  var mobileRegex =
    /Mobi|Android|webOS|iPhone|iPad|iPod|BlackBerry|IEMobile|Opera Mini/i;
  if (mobileRegex.test(userAgent)) {
    deviceInfo.isMobile = true;
  } else {
    deviceInfo.isMobile = false;
  }

  // 检测操作系统
  if (/Android/.test(userAgent)) {
    deviceInfo.os = "Android";
  } else if (/iPhone|iPad|iPod/.test(userAgent)) {
    deviceInfo.os = "IOS";
  } else if (/Windows NT/.test(userAgent)) {
    deviceInfo.os = "Windows";
  } else if (/Mac OS X/.test(userAgent)) {
    deviceInfo.os = "MacOS";
  } else if (/Linux/.test(userAgent)) {
    deviceInfo.os = "Linux";
  } else {
    deviceInfo.os = "Unknown";
  }

  // 检测浏览器
  if (/Chrome/.test(userAgent)) {
    deviceInfo.browser = "Chrome";
  } else if (/Firefox/.test(userAgent)) {
    deviceInfo.browser = "Firefox";
  } else if (/Safari/.test(userAgent)) {
    deviceInfo.browser = "Safari";
  } else if (/MSIE|Trident/.test(userAgent)) {
    deviceInfo.browser = "Internet Explorer";
  } else if (/Edge/.test(userAgent)) {
    deviceInfo.browser = "Edge";
  } else {
    deviceInfo.browser = "Unknown";
  }

  return deviceInfo;
}

export function isDarkMode() {
  return (
    window.matchMedia &&
    window.matchMedia("(prefers-color-scheme: dark)").matches
  );
}

export async function loadMarkdown(path: string) {
  const response = await fetch(path);
  const markdownText = await response.text();
  return markdownText;
}

// 检查是否可以后退
export function canGoBack() {
  return window.history.length > 1;
}

// 检查是否可以前进
export function canGoForward() {
  // 这个检查更复杂，因为需要知道当前页面是否是通过后退到达的
  // 以及是否有未来的页面可以前进到
  const state = history.state;
  if (state && state.forward) {
    return state.forward;
  }
  return false;
}

export function hadHistory() {
  return canGoBack() || canGoForward();
}

export const extractUUID = (input: string) => {
  const regex = /(\/.+)(\/.+)/;
  const match = input.match(regex);
  return match ? (match[2] ? match[2] : "") : "";
};

/**
 * map 对象匹配器
 * @param maps
 * @param key
 * @returns
 */
export const mapMatch = (maps: any, key: string) => {
  // 循环 maps 中的每个正则表达式
  for (const [regex, route] of maps) {
    if (regex.test(key)) {
      return route;
    }
  }
  return null;
};

export const expireFn = () => {
  localStorage.removeItem("good-user");
  // localStorage.removeItem("good-auth");
}

/**
 * 封装函数：动态生成表单并触发 POST 提交
 * @param {string} url - 目标 URL
 * @param {Object} params - 要传递的表单参数对象
 */
export const submitPostForm = (url, params = {}) => {
  // 检查参数是否为对象
  if (typeof params !== "object" || params === null) {
    console.error("参数必须是一个对象");
    return;
  }

  // 创建一个隐藏的表单
  const form = document.createElement("form");
  form.style.display = "none"; // 隐藏表单
  form.action = url; // 设置表单提交的目标 URL
  form.method = "post"; // 设置提交方式为 POST

  // 遍历参数对象，为每个键值对创建一个隐藏的输入字段
  for (const key in params) {
    if (params.hasOwnProperty(key)) {
      const input = document.createElement("input");
      input.type = "hidden"; // 设置为隐藏输入
      input.name = key; // 设置输入字段的名称
      input.value = params[key]; // 设置输入字段的值
      form.appendChild(input); // 将输入字段添加到表单中
    }
  }

  // 将表单添加到文档中
  document.body.appendChild(form);

  // 触发表单提交
  form.submit();

  // 提交后移除表单（可选，用于清理）
  document.body.removeChild(form);
}
